import { useState, useEffect } from 'react';
import { vehiclesAPI } from '../../services/api';

export const FUEL_LABELS = {
  essence: 'Essence', diesel: 'Diesel', hybride: 'Hybride', 'essence/électrique': 'Essence/électrique', 'diesel/électrique': 'Diesel/électrique',
  'essence/gpl': 'Essence / gaz combustible liquéfié (GPL)', 'essence/éthanol': 'Essence/éthanol', 'essence/éthanol/gaz': 'Essence / éthanol / gaz', 'électrique': 'Électrique', gpl: 'GPL/GNV',
};
export const FUEL_COLORS = {
  essence: 'bg-yellow-100 text-yellow-800', diesel: 'bg-gray-700 text-white', hybride: 'bg-green-100 text-green-800',
  'essence/électrique': 'bg-emerald-100 text-emerald-800', 'diesel/électrique': 'bg-teal-100 text-teal-800', 'essence/gpl': 'bg-fuchsia-100 text-fuchsia-800',
  'essence/éthanol': 'bg-lime-100 text-lime-800', 'essence/éthanol/gaz': 'bg-orange-100 text-orange-800', 'électrique': 'bg-blue-100 text-blue-800', gpl: 'bg-purple-100 text-purple-800',
};
export const getFuelLabel = (fuel) => FUEL_LABELS[fuel] || fuel;
export const getFuelColor = (fuel) => FUEL_COLORS[fuel] || 'bg-gray-100 text-gray-800';

const useAsync = (deps, enabled, fn, empty) => {
  const [data, setData] = useState(empty);
  const [loading, setLoading] = useState(enabled);
  useEffect(() => {
    if (!enabled) { setData(empty); return undefined; }
    let cancelled = false;
    setLoading(true);
    fn().then((d) => { if (!cancelled) setData(d); }).catch((e) => console.error('Vehicle data error:', e)).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
  return [data, loading, setData];
};

export const useVehicleData = (brand, model, year) => {
  const [full, loadingBrands] = useAsync([], true, () => vehiclesAPI.getBrandsFull(), { brands: [], logos: {}, popular: [] });
  const [modelsData, loadingModels, setModelsData] = useAsync([brand], !!brand, async () => {
    const [list, images] = await Promise.all([vehiclesAPI.getModels(brand), vehiclesAPI.getModelImages(brand).catch(() => ({}))]);
    return { list, images };
  }, { list: [], images: {} });
  const [years, loadingYears] = useAsync([brand, model], !!(brand && model), () => vehiclesAPI.getYears(brand, model), []);
  const [engines, loadingEngines] = useAsync([brand, model, year], !!(brand && model && year), () => vehiclesAPI.getEngines(brand, model, parseInt(year)), []);
  const setModelImages = (updater) => setModelsData((d) => ({ ...d, images: typeof updater === 'function' ? updater(d.images) : updater }));
  return {
    brands: full.brands || [], brandLogos: full.logos || {}, popularBrands: full.popular || [], loadingBrands,
    models: modelsData.list, modelImages: modelsData.images, setModelImages, loadingModels,
    years, loadingYears, engines, loadingEngines,
  };
};
